import { render, staticRenderFns } from "./SpirometryCreation.vue?vue&type=template&id=05797832&scoped=true"
import script from "./SpirometryCreation.vue?vue&type=script&lang=js"
export * from "./SpirometryCreation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05797832",
  null
  
)

export default component.exports